<div class="p-5 text-center" *ngIf="loading">
  <i class="fas fa-spinner fa-pulse fa-3x"></i>
</div>
<form #currentForm="ngForm" novalidate *ngIf="!loading">
  <legend>{{ matterHistory.id ? 'Editing History' : parent_id ? 'Reply to history' : 'New History' }}</legend>
  <hr class="mt-1 mb-2" />
  <div class="row">
    <div class="col-md-8">
      <div class="form-group">
        <label>Title</label>
        <input name="title" [(ngModel)]="matterHistory.title" type="text" class="form-control" />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <label>Message</label>
        <app-tinymce [initialContent]="matterHistory.message" (onEditorKeyup)="matterHistory.message = $event"></app-tinymce>
        <div *ngIf="!matterHistory.message && formSubmitted" class="text-danger">Please enter a history message</div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-8">
      <div class="form-group">
        <label>Tags</label>
        <input type="text" name="tags" [(ngModel)]="tags" class="form-control" />
        <small class="form-text text-muted">(comma separated)</small>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-8">
      <div class="form-group">
        <label>Type</label>
        <select required [class]="'form-control ' + (!matterHistory.matter_history_type_id && formSubmitted ? 'is-invalid' : '')" name="matter_history_type_id" [(ngModel)]="matterHistory.matter_history_type_id">
          <option *ngFor="let matter_history_type of formOptions.matter_history_types" [value]="matter_history_type.value">{{ matter_history_type.label }}</option>
        </select>
        <div *ngIf="!matterHistory.matter_history_type_id && formSubmitted" class="invalid-feedback">Please select a history type</div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-8">
      <div class="form-group">
        <label>Notify</label>
        <div class="card">
          <div class="card-body limited-height-extra-short">
            <div class="custom-controls-stacked">
              <div *ngFor="let email of formOptions.notification_emails" class="custom-control custom-checkbox" style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)" (click)="emailCheckBox.checked = !emailCheckBox.checked; emailChange(emailCheckBox.checked, email)">
                <input #emailCheckBox [name]="'notification-email-' + email" type="checkbox" class="custom-control-input" />
                <label class="custom-control-label">{{ email }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="custom-control custom-checkbox" (click)="matterHistory.notify_accounting = !matterHistory.notify_accounting">
          <input type="checkbox" name="notify_accounting" [(ngModel)]="matterHistory.notify_accounting" [checked]="matterHistory.notify_accounting" class="custom-control-input" />
          <label class="custom-control-label">Notify Accounting</label>
        </div>
      </div>
      <div class="form-group">
        <b>Notification Emails:&nbsp;&nbsp;</b>
        <app-badge badgeType="primary">{{ matter_history_emails.length }}</app-badge>
        <br />
        <div *ngFor="let email of matter_history_emails" class="text-info">{{ email }}</div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12 col-md-8">
      <div class="form-group">
        <label>Reminder Date/Time</label>
        <app-datetime-picker
          [showTimePicker]="true"
          (ngbResult)="matterHistory.reminder_date_struct = $event"
        ></app-datetime-picker>
      </div>
      <div class="form-group">
        <label>Notify reminder through</label>
        <br />
        <div *ngFor="let option of formOptions.deliver_options" class="custom-control custom-checkbox custom-control-inline" (click)="option.checked = !option.checked; setDeliveryMethods()">
          <input type="checkbox" [checked]="option.checked" class="custom-control-input" />
          <label class="custom-control-label">{{ option.label }}</label>
        </div>
        <small class="form-text text-muted">Browser Notification is the default option when none are selected.</small>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <label>Other Emails</label>
        <input type="text" [class]="'form-control ' + (invalidEmails() && formSubmitted ? 'is-invalid' : '')" name="other_emails" [(ngModel)]="other_emails" />
        <small class="form-text text-muted">(comma separated)</small>
        <div class="invalid-feedback" *ngIf="invalidEmails() && formSubmitted" [innerHTML]="invalidEmails() | safeHtml"></div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <b>Automatic Recipients:&nbsp;&nbsp;</b>
        <span *ngFor="let recipient of formOptions.automatic_recipients; let l = last">
          <span *ngIf="!recipient.allow_phone_text && matterHistory.reminder_delivery_methods.indexOf('Phone Text') > -1" class="text-danger" title="Texting not enabled">
            {{ recipient.name }}
            <span>
              <i class="fas fa-mobile-alt"></i>
              <i class="fas fa-slash" style="position: relative; left: -15px"></i>
            </span>
          </span>
          <span *ngIf="!(!recipient.allow_phone_text && matterHistory.reminder_delivery_methods.indexOf('Phone Text') > -1)">
            {{ recipient.name }}
          </span>
          <span *ngIf="!l">&nbsp;|&nbsp;</span>
        </span>
        <span *ngIf="formOptions.automatic_recipients.length > 0 && formOptions.other_emails.length > 0">&nbsp;|&nbsp;</span>
        <span *ngFor="let email of formOptions.other_emails; let l = last">
          <span>
            {{ email }}
          </span>
          <span *ngIf="!l">&nbsp;|&nbsp;</span>
        </span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <div *ngIf="!formValid() && formSubmitted" class="text-danger">Please correct form errors above</div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 text-center">
      <button type="button" class="btn btn-primary" (click)="submitForm()" [disabled]="formSubmitting">
        <span *ngIf="formSubmitting"> Submitting <i class="fas fa-spinner fa-pulse fa-fw"></i> </span>
        <span *ngIf="!formSubmitting">{{ matterHistory.id ? 'Update' : parent_id ? 'Reply' : 'Create' }}</span>
      </button>
      &nbsp;
      <button type="button" class="btn btn-secondary" [disabled]="formSubmitting" (click)="cancelForm()">Cancel</button>
    </div>
  </div>
</form>
